// Casino category ("list") pages — games, order and banner file per list, exactly as the
// reference admin (allpanel9.global/admin/casino/<list>). `img` is a file in
// src/assets/images/thumbs (copied byte-for-byte from the reference's
// cdn.926assets.com/.../admin/img/banners/), `path` is our route for that game.
// Reference hrefs use long slugs (e.g. teenpattit20); ours use the gtype slug (teen20).

// Every reference item is listed (count/order/banners verified item-by-item against the live
// reference, banner bytes identical to cdn.926assets.com). Items marked "no local route yet"
// need a route in App.jsx; until then they fall through to the catch-all.
export const CASINO_GAME_LISTS = {
  tembo: [
    { img: "tteen.jpg", path: "/admin/casino/tteen" },
    { img: "tteen20.jpg", path: "/admin/casino/tteen20" },
    { img: "tdt20.jpg", path: "/admin/casino/tdt20" },
    { img: "tdt6.jpg", path: "/admin/casino/tdt6" },
    { img: "tlucky7.jpg", path: "/admin/casino/tlucky7" },
    { img: "tcard32.jpg", path: "/admin/casino/tcard32" },
    { img: "tbaccarat.jpg", path: "/admin/casino/tbaccarat" },
  ],
  // Reference VIP list: one game (20-20 Teenpatti VIP; API type teen20v1)
  vip: [{ img: "teen20v1_admin.gif", path: "/admin/casino/teen20v", video: true }], // file is an MP4
  roulette: [
    { img: "ourroullete.jpg", path: "/admin/casino/ourroullete" },
    { img: "roulette11.jpg", path: "/admin/casino/roulette11" },
    { img: "roulette12.jpg", path: "/admin/casino/roulette12" },
    { img: "roulette13.jpg", path: "/admin/casino/roulette13" },
  ],
  worli: [
    { img: "worli.jpg", path: "/admin/casino/worli" },
    { img: "worli2.jpg", path: "/admin/casino/worli2" },
    { img: "worli3.gif", path: "/admin/casino/worli3" },
  ],
  card32: [
    { img: "card32.jpg", path: "/admin/casino/card32" },
    { img: "card32eu.jpg", path: "/admin/casino/card32eu" },
  ],
  andarbahar: [
    { img: "andar-bahar2.jpg", path: "/admin/casino/abj" },
    { img: "andar-bahar.jpg", path: "/admin/casino/ab20" },
    { img: "ab3.jpg", path: "/admin/casino/ab3" },
    { img: "ab4.jpg", path: "/admin/casino/ab4" },
  ],
  baccarat: [
    { img: "baccarat2.jpg", path: "/admin/casino/baccarat2" },
    { img: "baccarat.jpg", path: "/admin/casino/baccarat" },
    { img: "teensin.jpg", path: "/admin/casino/teensin" },
  ],
  sports: [
    { img: "superover3.jpg", path: "/admin/casino/superover3" },
    { img: "superover2.jpg", path: "/admin/casino/superover2" },
    { img: "superover.jpg", path: "/admin/casino/superover" },
    { img: "cricketv3.jpg", path: "/admin/casino/cricketv3" },
    { img: "cc-20.jpg", path: "/admin/casino/cmatch20" },
    { img: "cmeter.jpg", path: "/admin/casino/cmeter" },
    { img: "cmeter1.jpg", path: "/admin/casino/cmeter1" },
  ],
  liveteenpatti: [
    { img: "teen20.jpg", path: "/admin/casino/teen20" },
    { img: "teen.jpg", path: "/admin/casino/teen" },
    { img: "teen9.jpg", path: "/admin/casino/teen9" },
    { img: "teen8.jpg", path: "/admin/casino/teen8" },
    { img: "teen33.jpg", path: "/admin/casino/teen33" },
    { img: "teen3.jpg", path: "/admin/casino/teen3" },
    { img: "teen32.jpg", path: "/admin/casino/teen32" },
    { img: "teen20b.jpg", path: "/admin/casino/teen20b" },
    { img: "teenmuf.jpg", path: "/admin/casino/teenmuf" },
    { img: "patti2.jpg", path: "/admin/casino/patti2" },
    { img: "teen41.jpg", path: "/admin/casino/teen41" },
    { img: "teen42.jpg", path: "/admin/casino/teen42" },
    { img: "teen20c.jpg", path: "/admin/casino/teen20c" },
    { img: "teenjoker.jpg", path: "/admin/casino/teenjoker" }, // no local route yet
    { img: "joker1.jpg", path: "/admin/casino/joker1" }, // no local route yet
    { img: "joker20.jpg", path: "/admin/casino/joker20" },
    { img: "joker120.jpg", path: "/admin/casino/joker120" }, // no local route yet
    { img: "poison20.jpg", path: "/admin/casino/poison20" },
    { img: "poison.jpg", path: "/admin/casino/poison" },
    { img: "teen62.jpg", path: "/admin/casino/teen62" },
  ],
  teenpatti2: [{ img: "teen6.jpg", path: "/admin/casino/teen6" }],
  poker: [
    { img: "poker20.jpg", path: "/admin/casino/poker20" },
    { img: "poker.jpg", path: "/admin/casino/poker" },
    { img: "poker6.jpg", path: "/admin/casino/poker6" },
  ],
  lucky7: [
    { img: "lucky7.jpg", path: "/admin/casino/lucky7" },
    { img: "lucky7eu.jpg", path: "/admin/casino/lucky7eu" },
    { img: "lucky7eu2.jpg", path: "/admin/casino/lucky7eu2" },
  ],
  dragontiger: [
    { img: "dt202.jpg", path: "/admin/casino/dt202" },
    { img: "dtl20.jpg", path: "/admin/casino/dtl20" },
    { img: "dt20.jpg", path: "/admin/casino/dt20" },
    { img: "dt6.jpg", path: "/admin/casino/dt6" },
  ],
  bollywood: [
    { img: "aaa.jpg", path: "/admin/casino/aaa" },
    { img: "btable.jpg", path: "/admin/casino/btable" },
    { img: "aaa2.jpg", path: "/admin/casino/aaa2" },
    { img: "btable2.jpg", path: "/admin/casino/btable2" },
  ],
  // Not on the reference menu (ours only) — kept, in the reference card markup
  cricket: [
    { img: "superover.jpg", path: "/admin/casino/superover" },
    { img: "superover2.jpg", path: "/admin/casino/superover2" },
    { img: "superover3.jpg", path: "/admin/casino/superover3" },
  ],
  others: [
    { img: "lottery.jpg", path: "/admin/casino/lottcard" },
    { img: "race2.jpg", path: "/admin/casino/race2" },
    { img: "race17.jpg", path: "/admin/casino/race17" },
    { img: "sicbo.jpg", path: "/admin/casino/sicbo" },
    { img: "dum10.jpg", path: "/admin/casino/dum10" },
    { img: "teen1.jpg", path: "/admin/casino/teen1" },
    { img: "teen120.jpg", path: "/admin/casino/teen120" }, // no local route yet
    { img: "ballbyball.jpg", path: "/admin/casino/ballbyball" }, // no local route yet
    { img: "kbc.jpg", path: "/admin/casino/kbc" },
    { img: "notenum.jpg", path: "/admin/casino/notenum" },
    { img: "trio.jpg", path: "/admin/casino/trio" },
    { img: "trap.jpg", path: "/admin/casino/trap" },
    { img: "sicbo2.jpg", path: "/admin/casino/sicbo2" },
    { img: "dolidana.gif", path: "/admin/casino/dolidana" },
  ],
};
